import React from 'react';
import { DataTable } from '../../../../ui';
import { SecurityLog, getSecurityLogColumns } from './Functions/GetColumns';

const SecurityLogTab = () => {
  const logs: SecurityLog[] = [
    {
      id: 1,
      action: 'User Login',
      user: 'Jane Doe',
      ip: '192.168.1.1',
      timestamp: '2024-03-02 10:15:30',
    },
    {
      id: 2,
      action: 'License Updated',
      user: 'John Smith',
      ip: '192.168.1.5',
      timestamp: '2024-03-02 09:45:00',
    },
    {
      id: 3,
      action: 'New User Invited',
      user: 'Jane Doe',
      ip: '192.168.1.1',
      timestamp: '2024-03-01 16:20:15',
    },
    {
      id: 4,
      action: 'Security Settings Changed',
      user: 'System',
      ip: '-',
      timestamp: '2024-03-01 12:00:00',
    },
  ];

  const columns = getSecurityLogColumns();

  return (
    <div className='space-y-8'>
      <div>
        <h1 className='text-3xl font-black text-slate-800 tracking-tighter'>
          Security & Audit Log
        </h1>
        <p className='text-slate-500 font-medium'>
          Track all administrative actions and security-related events.
        </p>
      </div>

      <div className='bg-white border border-slate-100 shadow-sm overflow-hidden'>
        <DataTable
            columns={columns}
            data={logs}
            rowsPerPage={10}
            totalRecords={logs.length}
            totalPages={1}
            currentPage={1}
            onPageChange={() => {}}
        />
      </div>
    </div>
  );
};

export default SecurityLogTab;
